// commissionsApi.js
/* (RTK Query service) */

import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { URLAPI } from "../../configuration";

const rawBaseQuery = fetchBaseQuery({
    baseUrl: URLAPI,
    prepareHeaders: (h, { getState }) => {
        const token = getState().auth.user.jwt;
        if (token) h.set("Authorization", `Bearer ${token}`);
        return h;
    },
});

const baseQuery = retry(rawBaseQuery, {
    maxRetries: 20, // ⇒ 1 first try + 20 re-tries
    // retryCondition: (error) => error?.status >= 500, // optional
});

export const commissionsApi = createApi({
    reducerPath: "commissionsApi",
    baseQuery,
    tagTypes: ["Commissions"],
    endpoints: (builder) => ({
        getCommissions: builder.query({
            query: ({ year }) => ({
                url: `/commission3?year=${year}`,
                method: "GET",
            }),
            keepUnusedDataFor: 60 * 30,
            providesTags: (result, _err, arg) =>
                result ? [{ type: "Commissions", id: arg.year }] : [],
            transformResponse: (response) => {
                // Comment: pick global-ish fields you want to aggregate once
                const {
                    currencies,
                    currency_codes,
                    currency_symbols,
                    exchange_rates,
                    version,
                    cache_ttl,
                } = response ?? {};

                // Comment: keep the full original response as per-year payload,
                // but remove the fields that you moved to `extra` if you don't
                // want them duplicated under each year.
                const payload = { ...response };
                delete payload?.currencies;
                delete payload?.currency_codes;
                delete payload?.currency_symbols;
                // If you also want exchange_rates only under extra, uncomment:
                // delete payload?.exchange_rates;

                return {
                    payload,
                    cache_ttl: cache_ttl ?? null,
                    extra: {
                        ...(currencies && { currencies }),
                        ...(currency_codes && { currency_codes }),
                        ...(currency_symbols && { currency_symbols }),
                        ...(exchange_rates && { exchange_rates }),
                        ...(version && { version }),
                    },
                };
            },
        }),
    }),
});

export const { useGetCommissionsQuery, useLazyGetCommissionsQuery } =
    commissionsApi;
